import { AdMob, AdmobConsentStatus } from '@capacitor-community/admob';
import { ConsentProvider } from '../consent';

export class AdmobConsentProvider implements ConsentProvider {
  private consented = false;

  async initialize(): Promise<boolean> {
    try {
      const info = await AdMob.requestConsentInfo();
      if (info.isConsentFormAvailable && info.status === AdmobConsentStatus.REQUIRED) {
        const updated = await AdMob.showConsentForm();
        this.consented = updated.canRequestAds;
      } else {
        this.consented = info.canRequestAds;
      }
      await AdMob.requestTrackingAuthorization();
      return this.consented;
    } catch {
      this.consented = true;
      return true;
    }
  }

  hasConsent(): boolean {
    return this.consented;
  }

  async requestConsent(): Promise<boolean> {
    try {
      const info = await AdMob.showConsentForm();
      this.consented = info.canRequestAds;
      return this.consented;
    } catch {
      return this.consented;
    }
  }
}
